import { useContext, useEffect, useMemo, useState } from "react";
import { Context } from "../../App";
import { Box, TextField, Paper, Typography, Stack, Button, Grid2 } from "@mui/material";

export default function BilletsForm({ events, selectedEvent, updateBillets, close }) {
    const {setIsConnected} = useContext(Context);
    const user = JSON.parse(sessionStorage.getItem('user'));
    const [load, setLoad] = useState(true);
    const [eventId, setEventId] = useState(selectedEvent || '');
    const [billets, setBillets] = useState([]);

    const tarifs = [{ nom: 'Gratuit', montant: 0 }, { nom: 'Cadeau', montant: 0 }];

    const event = useMemo(() => events.find(p => p._id === eventId), [eventId, events]);
    const billetModel = useMemo(() => ({
        owner: {
            id: user?._id || '',
            nom: '',
            prenom: ''
        },
        event: eventId,
        statut: 'valide',
        by: user?._id || ''
    }), [user, eventId]);

    async function handleSubmit(e) {
        e.preventDefault();
        setLoad(true);
        try {
            fetch(process.env.REACT_APP_API_URL.concat('/adm/billets/create'), {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token')
                },
                body: JSON.stringify(billets)
            }).then(async response => {
                const token = response.headers.get('x-auth-token');
                if (response.status === 401) {
                    sessionStorage.clear();
                    setIsConnected(false);
                } else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'));
                    }
                    if (response.status === 201) {
                        const json = await response.json();
                        updateBillets(json);
                        close();
                    } else {
                        throw new Error('Failed to create billets');
                    }
                }
            }).catch(error => {
                console.error("Error creating billets:", error);
                setLoad(false);
                throw error;
            });
        } catch (error) {
            console.error("Error in handleSubmit:", error);
            setLoad(false);
            throw error;
        }
    }

    useEffect(() => {
        if(billets.length >0) {
            setBillets(old => old.map(b => ({ ...b, event: eventId })));
        }
    }, [eventId])


    return(
        <Box component='form' onSubmit={handleSubmit} sx={{ p:2, display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Typography variant="h4" align="center" sx={{ mb: 2, color: 'primary.main'}}>Nouveaux billets</Typography>

            <TextField select label="Événement" value={eventId} onChange={(e) => setEventId(e.target.value)} size="small"
            sx={{ minWidth: '200px', width: '30%' }} slotProps={{ select: { native: true }, inputLabel:{shrink: true} }}>
                <option value="" disabled>Choisissez un événement</option>
                {events.map((event) => <option key={event._id} value={event._id}>{event.titre}</option>)}
            </TextField>

            <Grid2 container spacing={2} >
            {event && tarifs.map((tarif, index) => (
                <Grid2 item key={index} size={{ sm: 12, md: 6 }}>
                <Paper elevation={3} sx={{ padding: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderRadius:2 }}key={index}>
                    <Box>
                        <Typography variant="h6" sx={{ flexGrow: 1 }}>{tarif.nom}</Typography>
                        <Typography variant="body1" sx={{ marginLeft: 2 }}>{tarif.montant.toFixed(2)} €</Typography>
                    </Box>
            
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Button variant="outlined" size="small" color="primary" sx={{ width: 30, padding: 0, minWidth: 0, borderRadius: 2 }}
                        inputProps={{ style: { display: 'none', } }}
                        onClick={()=>{if(billets.filter(bl=>bl.tarif === tarif.nom).length > 0) setBillets(old=> {
                            const reverse = old.reverse();
                            const lastIndex = reverse.findIndex(bl => bl.tarif === tarif.nom); 
                            return reverse.filter((_, i) => i !== lastIndex).reverse();
                        })}}>-</Button>

                        <Typography variant="body1" sx={{ width: 50, border:'1px solid black', borderRadius: 2, textAlign:'center', px:1 }}>{billets.filter(bl=>bl.tarif === tarif.nom).length}</Typography>

                        <Button variant="outlined" size="small" color="primary" sx={{ width: 30, padding: 0, minWidth: 0, borderRadius: 2 }} 
                        onClick={()=>setBillets(old=>[...old, { ...billetModel, tarif: tarif.nom, price: tarif.montant }])}>+</Button>
                    </Stack>
                </Paper>
                </Grid2>
            ))}
            </Grid2>

            {billets.map((billet, index) => (
                <Paper key={index} sx={{ display:'flex', flexDirection:'column', minWidth: '400px', borderRadius: 2, overflow: 'hidden' }}>
                    <Box sx={{px:4, py:2, backgroundColor: 'focus.main', color: 'white', mb:2}}>
                        <Typography variant="h6" color="white">{event.titre} - {billet.tarif} - {billet.price?.toFixed(2)} €</Typography>
                        <Typography variant="body1" color="secondary.main" fontSize={16}>Participant #{index+1}</Typography>
                    </Box>
            
                    <Box sx={{ px: 2 }}>
                        <TextField fullWidth label="Nom" variant="outlined" value={billet.owner.nom} required sx={{ mb: 2 }}
                        onChange={(e) => setBillets(old => old.map(b => b === billet ? { ...b, owner: { ...b.owner, nom: e.target.value } } : b))} />
                        <TextField fullWidth label="Prénom" variant="outlined" value={billet.owner.prenom} required sx={{ mb: 2 }}
                        onChange={(e) => setBillets(old => old.map(b => b === billet ? { ...b, owner: { ...b.owner, prenom: e.target.value } } : b))} />
                    </Box>

                </Paper>
            ))}

            {event && billets.length > 0 &&<Button variant="contained" type="submit" sx={{ mt: 2, alignSelf:'center' }}>Valider</Button>}

        </Box>
    )
}